module.exports = __webpack_public_path__ + "img/oneMoreThing.9211c5d3.svg";